import {AUTH_TOKEN} from "./constants";
import {JwtToken} from "../../types";

export function getJWTToken (): string | null {
    return localStorage.getItem(AUTH_TOKEN);
}

export function setJWTToken(token: JwtToken): void {
    localStorage.setItem(AUTH_TOKEN, token as any);
}

export function removeJWTToken (): void {
    localStorage.removeItem(AUTH_TOKEN);
}
